import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";

import { Link } from "react-router-dom";

import axios from "axios";

import { Button } from "components";

import nowLogo from "assets/img/nadu-logo-full.png";

import bgImage1 from "assets/img/minibg/bg1.jpg";
import bgImage2 from "assets/img/minibg/bg2.jpg";
import bgImage3 from "assets/img/minibg/bg3.jpg";
import bgImage4 from "assets/img/minibg/bg4.jpg";
import bgImage5 from "assets/img/minibg/bg5.jpg";
import bgImage6 from "assets/img/minibg/bg6.jpg";
import bgImage7 from "assets/img/minibg/bg7.jpg";
import bgImage8 from "assets/img/minibg/bg8.jpg";
import bgImage9 from "assets/img/minibg/bg9.jpg";
import bgImage10 from "assets/img/minibg/bg10.jpg";
import bgImage11 from "assets/img/minibg/bg11.jpg";
import bgImage12 from "assets/img/minibg/bg12.jpg";
import Cookies from "universal-cookie";
// import FaceDetection from "views/FaceDetection/FaceDetection.jsx";
const cookies = new Cookies();

// const API = "https://mi-tienda.nadunet.es/api/rest/";
const API = !window.location.host.includes("localhost") ? "https://" + window.location.host + "/api/rest/" : "https://oficina.nadunet.es/api/rest/";
const GET_USERNAME_URL = "nadulogin_resources/get_username.json";
const DO_LOGIN_URL = "user/login";
const LOGIN_URL = "nadulogin_resources/login";
const GET_TOKEN_URL = "user/token";
const DO_LOGOUT_URL = "user/logout";
const bgs = [
  bgImage1,
  bgImage2,
  bgImage3,
  bgImage4,
  bgImage5,
  bgImage6,
  bgImage7,
  bgImage8,
  bgImage9,
  bgImage10,
  bgImage11,
  bgImage12
];
const recuperarPassStyle = {
  textAlign: "center"
};
class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    //if (this.props.mainState.debug) //console.log("########## PROPS LOGIN ###########");
    //if (this.props.mainState.debug) //console.log(props);
    let fields = {
      login: "dniField",
      pass: "passField"
    };
    let randomBgNumber = this.randomIntFromInterval(0, 11);
    let randomBg = bgs[randomBgNumber];

    this.state = {
      fields: fields,
      [fields.login]: "",
      [fields.pass]: "",
      username: "",
      loginError: false,
      isLogging: false,
      randomBg: randomBg
    };

    this.startLogin = this.startLogin.bind(this);
    this.getUsername = this.getUsername.bind(this);
    this.doLogin = this.doLogin.bind(this);
    this.getLoginButton = this.getLoginButton.bind(this);
    this.handleLoginError = this.handleLoginError.bind(this);
    this.cleanSession = this.cleanSession.bind(this);
    this.miniLogout = this.miniLogout.bind(this);
    this.showLoginError = this.showLoginError.bind(this);
  }
  getLoginButton() {
    let loginButton = null;

    if(this.state.isLogging){
      loginButton = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }else{
      loginButton = "Iniciar sesión";
    }

    return loginButton;
  }
  startLogin() {
    alert("Usuario: " + this.state.dniField +"\nContraseña: " + this.state.passField);
    this.getUsername();
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  getUsername(option) {
    if (this.state.isLogging && !option) return;
    /* //////console.log("################## GET USERNAME ################"); */

    this.setState({
      isLogging: true
    });

    let request = {
      dni: this.state.dniField,
      password: this.state.passField
    };
    /* //////console.log(request); */
    //this.setState({ isLoading: true });
    axios.post(API + GET_USERNAME_URL, request,{withCredentials: false})
      .then(result => {
        /* //////console.log("################## RESPUESTA ################");
        //////console.log(result); */
        if(result !== null && result.data.length > 0 && result.data[0] !== ""){
          this.setState({
            username: result.data[0],
            loginError: false
          });
          this.doLogin();
        }else{
          this.setState({
            loginError: true,
            isLogging: false
          });
          this.showLoginError();
        }
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            /* //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers); */

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            /* //////console.log(error.request); */
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            /* //////console.log('Error', error.message); */
            this.setState({
              error,
              isLogging: false
            });
        }
        /* //////console.log(error.config); */
      });
  }
  showLoginError() {
    var options = {
      place: "tr",
      message: "Credenciales incorrectas",
      type: "danger",
      icon: "now-ui-icons objects_key-25",
      autoDismiss: 3
    };
    this.props.showNotification(options);
  }
  doLogin(option) {
    if (this.state.isLogging && !option) return;
    /* //////console.log("################## DO LOGIN ################"); */
    this.setState({
      isLogging: true
    });

    let request = {
      dni: this.state.dniField,
      password: this.state.passField
    };
    // let request = {
    //   username: this.state.dniField,
    //   password: this.state.passField
    // };
    /* //////console.log(request); */
    //this.setState({ isLoading: true });
    axios.post(API + LOGIN_URL, request, {withCredentials: false})
      .then(result => {
        // console.log("################## RESPUESTA LOGIN ################");
        // console.log(result);
        this.setState({
          isLogging: false
        });
        this.props.godMode(result, false, this.state.passField);
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            /* //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers); */

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            /* //////console.log(error.request); */
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            /* //////console.log('Error', error.message); */
            this.setState({
              error,
              isLogging: false
            });
        }
        /* //////console.log(error.config); */
      });
  }
  handleLoginError(error) {
    //////console.log("#################### HANDLE ERROR ##################");
    //////console.log(error);
    switch (error) {
      case 401:
        this.cleanSession();
        this.getUsername(error);
        break;
      case 500:
        this.getUsername(error);
        break;
      case 666:
        this.getUsername(error);
        break;
      default:
        break;
    }
  }
  cleanSession() {
    let request = {};
    let newToken = "";

    //this.setState({ isLoading: true });
    axios.post(API + GET_TOKEN_URL, request, {withCredentials: true})
      .then(result => {
        //////console.log("################## RESPUESTA GET TOKEN ################");
        //////console.log(result);
        newToken = result.data.token;
        this.miniLogout(newToken);
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers);

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            //////console.log(error.request);
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            //////console.log('Error', error.message);
            this.setState({
              error,
              isLogging: false
            });
        }
        //////console.log(error.config);
      });
  }
  miniLogout(newToken) {
    let request = {};
    let queryHeaders = {
      headers:{
        "X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
    axios
      .post(API + DO_LOGOUT_URL, request, {
        headers: queryHeaders.headers,
        withCredentials: true
      })
      .then(result => {
        //////console.log("################## RESPUESTA LOGOUT ################");
        //////console.log(result);
        
        if(result.data[0]) {
          this.getUsername();
        } else {
          this.cleanSession();
        }
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers);

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            //////console.log(error.request);
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            //////console.log('Error', error.message);
            this.setState({
              error,
              isLogging: false
            });
        }
        //////console.log(error.config);
      });
  }
  randomIntFromInterval(min,max) {
      return Math.floor(Math.random()*(max-min+1)+min);
  }
  render() {
    let fields = this.state.fields;
    let loginErrorMessage =    
      <div className="pull-left link footer-link">
        <h6>
            Credenciales incorrectas
        </h6>
      </div>;
      // console.log("this.props.userData", this.props.userData);
    if (this.state.faceLogin) return (
        <div>
          <div className="full-page-content">
            <div className="login-page">
              {/* <FaceDetection
                {...this.props}
                mainState={this.props.mainState}
                userData={this.props.userData} /> */}
            </div>
          </div>
        </div>
      );
    return (
      <div>
        <div className="full-page-content">
          <div className="login-page">
            <Container>
              <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
                <Form>
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="now-logo" />
                      </div>
                    </CardHeader>
                    <CardBody>
                      <InputGroup
                        className={
                          "no-border form-control-lg " +
                          (this.state.firstnameFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons users_circle-08" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="DNI"
                          onFocus={e => this.setState({ firstnameFocus: true })}
                          onBlur={e => this.setState({ firstnameFocus: false })}
                          value={this.state[fields.login]}
                          onChange={(e) => this.handleChange(fields.login, e)}
                        />
                      </InputGroup>
                      <InputGroup
                        className={
                          "no-border form-control-lg " +
                          (this.state.lastnameFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons objects_key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Contraseña"
                          onFocus={e => this.setState({ lastnameFocus: true })}
                          onBlur={e => this.setState({ lastnameFocus: false })}
                          value={this.state[fields.pass]}
                          onChange={(e) => this.handleChange(fields.pass, e)}
                        />
                      </InputGroup>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button
                        block
                        round
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={this.doLogin/*this.getUsername*/}
                      >
                        {this.getLoginButton()}
                      </Button>
                      <Button
                        round
                        block
                        // leftLabel={"now-ui-icons users_circle-08"}
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={() => this.setState({ faceLogin: true })}
                      >
                        <i className="2x now-ui-icons users_circle-08" />{" "}Reconocimiento facial
                      </Button>
                      {/*<div style={recuperarPassStyle}>
                        <Link to="/recuperar">Recuperar contraseña</Link>
                      </div>*/}
                      {/* this.state.loginError && loginErrorMessage */}
                      {/* <div className="pull-right">
                        <h6>
                          <a href="#pablo" className="link footer-link">
                            Need Help?
                          </a>
                        </h6>
                      </div> */}
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
        />
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx